import moment from 'moment'
import { downloadFileRequest, jsonRequest } from '../helpers/apiRequest'
import { baseUrl } from '../helpers/baseUrl'
import { getUrlWithQueryString } from '../helpers/util'

let transcationEndPoint = 'transaction/v2'

export let setTranscationEndPoint = endPoint => {
  //transcationEndPoint = endPoint
}

export let getTranscationEndPoint = () => {
  return 'elastictransaction' // transcationEndPoint
}

export function fetchPaginatedStatementsAjax({
  accountId,
  startDate = moment().subtract(6, 'months'),
  endDate = moment(),
  searchId = null,
  IsEquivalent = null,
  accountHolderPersonalNumber = null,
  takeNextCount = 30,
  signal = null
}) {
  startDate = moment(startDate)
    .startOf('day')
    .unix()
  endDate = moment(endDate)
    .endOf('day')
    .unix()

  const params = {
    accountId,
    startDate,
    endDate,
    ...(searchId && { searchId }),
    takeNextCount: takeNextCount
  }
  //
  if (IsEquivalent) params.IsEquivalent = IsEquivalent
  if (accountHolderPersonalNumber) {
    params.accountHolderPersonalNumber = accountHolderPersonalNumber
    params.isJuniorAccount = true
  }

  let url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/statements/paged`,
    params
  )

  return jsonRequest(
    url,
    true,
    undefined,
    'GET',
    { internalServerError: false, badRequest: false },
    signal
  )
}

export function fetchStatementsAjax(
  accountId = null,
  startDate = moment().subtract(6, 'months'),
  endDate = moment(),
  signal = null
) {
  startDate = moment(startDate)
    // .local()
    .startOf('day')
    .unix()

  endDate = moment(endDate)
    // .local()
    .endOf('day')
    .unix()

  const url = accountId
    ? `${baseUrl}/${transcationEndPoint}/statements?accountId=${accountId}&StartDate=${startDate}&EndDate=${endDate}`
    : `${baseUrl}/${transcationEndPoint}/statements?StartDate=${startDate}&EndDate=${endDate}`
  return jsonRequest(
    url,
    true,
    undefined,
    'GET',
    { internalServerError: false, badRequest: false },
    signal
  )
}

export function exportStatements(
  account,
  startDate = moment().subtract(6, 'months'),
  endDate = moment(),
  format
) {
  if (!account) {
    return
  }
  startDate = moment(startDate)
    // .local()
    .startOf('day')
    .unix()
  endDate = moment(endDate)
    // .local()
    .endOf('day')
    .unix()

  const url = `${baseUrl}/${transcationEndPoint}/statements/export/${
    format === 'xls' ? 'excel' : format
  }?AccountId=${account}&StartDate=${startDate}&EndDate=${endDate}`

  return downloadFileRequest(url, 'AccountStatements', format, true)
}

export function exportStatementsAsync({
  account,
  startDate = moment().subtract(1, 'months'),
  endDate = moment(),
  format,
  accountHolderPersonalNumber = null
}) {
  if (!account) {
    return
  }
  startDate = moment(startDate)
    .startOf('day')
    .unix()
  endDate = moment(endDate)
    .endOf('day')
    .unix()

  const url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/statements/export/${
      format === 'xls' ? 'excel' : format
    }-async`,
    {
      AccountId: account,
      StartDate: startDate,
      EndDate: endDate,
      accountHolderPersonalNumber,
      isJuniorAccount: !!accountHolderPersonalNumber
    }
  )

  return jsonRequest(url, true, undefined, 'GET')
}

export function checkStatementsFileStatus(fileId) {
  const url = `${baseUrl}/${transcationEndPoint}/statements/export/check-file-status?FileId=${fileId}`

  return jsonRequest(url, true, undefined, 'GET')
}

export function getStatementsFile(fileId, format) {
  const url = `${baseUrl}/${transcationEndPoint}/statements/export/get-file?FileId=${fileId}`

  return downloadFileRequest(url, 'AccountStatements', format, true)
}
export const fetchMonthlyTurnoverAjax = (startDate, endDate) => {
  // eslint-disable-next-line max-len
  let url = `${baseUrl}/${transcationEndPoint}/finanncial-summary/monthly-turnover?startDate=${startDate}&endDate=${endDate}`
  return jsonRequest(url, true)
}
export const fetchCurrentTurnoverState = () => {
  let url = `${baseUrl}/${transcationEndPoint}/finanncial-summary/state`
  return jsonRequest(url, true)
}

export function fetchTransactionsAjax(
  {
    iban,
    keyword,
    skip = 0,
    take = 30,
    loadMoreTransactions = false,
    startDate,
    endDate,
    currency,
    amountFrom,
    amountTo,
    categoryId,
    subcategoryId,
    type,
    searchId,
    IsJuniorAccount,
    accountHolderPersonalNumber
  },
  signal = null
) {
  const params = {}
  if (iban) params.iban = iban
  if (currency) params.currency = currency

  if (keyword) params.keyword = keyword

  if (skip) params.skip = skip
  if (categoryId) params.categoryId = categoryId
  if (subcategoryId) params.subcategoryId = subcategoryId
  if (take) params.take = loadMoreTransactions ? take : take

  if (startDate) params.startDate = startDate.startOf('day').unix()
  if (endDate) params.endDate = endDate.endOf('day').unix()

  if (amountFrom) params.fromAmount = amountFrom
  if (amountTo) params.toAmount = amountTo
  if (type) params.type = type
  if (searchId) params.searchId = searchId

  if (IsJuniorAccount) params.IsJuniorAccount = IsJuniorAccount

  if (accountHolderPersonalNumber)
    params.accountHolderPersonalNumber = accountHolderPersonalNumber

  let url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/transactions/paged`,
    params
  )
  return jsonRequest(
    url,
    true,
    undefined,
    'GET',
    { internalServerError: false, badRequest: false },
    signal
  )
}

export function exportTransactions({
  iban,
  keyword,
  startDate,
  endDate,
  currency,
  amountFrom,
  amountTo,
  type,
  accountHolderPersonalNumber,
  isJuniorAccount
}) {
  const params = {}
  if (iban) params.iban = iban
  if (currency) params.currency = currency
  if (keyword) params.keyword = keyword
  if (startDate) params.startDate = startDate.startOf('day').unix()
  if (endDate) params.endDate = endDate.endOf('day').unix()

  if (amountFrom) params.fromAmount = amountFrom
  if (amountTo) params.toAmount = amountTo
  if (type) params.type = type
  if (accountHolderPersonalNumber && isJuniorAccount)
    params.accountHolderPersonalNumber = accountHolderPersonalNumber
  if (isJuniorAccount) params.isJuniorAccount = isJuniorAccount

  let url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/transactions/export/excel`,
    params
  )
  return downloadFileRequest(url, 'Transactions', 'xls', true)
}

export function fetchGetBlockedAmountAjax(params = {}) {
  let query = Object.keys(params).reduce((acc, key) => {
    if (params[key] !== null && params[key] !== undefined) {
      acc[key] = params[key]
    }
    return acc
  }, {})
  const url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/blocked-amounts`,
    query
  )
  return jsonRequest(url, true)
}

export function fetchGetOtherBlockedAmountAjax(params = {}) {
  let query = Object.keys(params).reduce((acc, key) => {
    if (params[key] !== null && params[key] !== undefined) {
      acc[key] = params[key]
    }
    return acc
  }, {})
  const url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/blocked-amounts/other`,
    query
  )
  return jsonRequest(url, true)
}

export function fetchGetBlockedAmountByCardIdAjax(cardId) {
  var url = `${baseUrl}/${transcationEndPoint}/blocked-amounts/${encodeURIComponent(
    cardId
  )}`
  return jsonRequest(url, true)
}

export function fetchTransactionsDetailsAjax({
  id,
  transactionDate,
  routingKey,
  accountHolderPersonalNumber = null,
  isJuniorAccount = null
} = {}) {
  const params = {
    id,
    TransactionDate: transactionDate,
    RoutingKey: routingKey
  }
  if (accountHolderPersonalNumber) {
    params.AccountHolderPersonalNumber = accountHolderPersonalNumber
    params.IsJuniorAccount = !!accountHolderPersonalNumber || isJuniorAccount
  }

  const url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/transactions/details`,
    params
  )
  return jsonRequest(url, true)
}

export function changeFinancialCategory({
  id,
  transactionDate,
  categoryId,
  subcategoryId
}) {
  let url = `${baseUrl}/${transcationEndPoint}/finanncial-summary/change-financial-category`
  return jsonRequest(
    url,
    true,
    {
      transactionId: id,
      transactionDate,
      categoryId,
      subcategoryId
    },
    'POST'
  )
}

export function changeIncludeinSummary(id, transactionDate, includeInSummary) {
  let url = `${baseUrl}/${transcationEndPoint}/finanncial-summary/change-include-in-summary`
  return jsonRequest(
    url,
    true,
    {
      transactionId: id,
      transactionDate,
      includeInSummary
    },
    'POST'
  )
}

export function fetchBlockedAmmountProductsCommissionAjax() {
  return jsonRequest(
    `${baseUrl}/${transcationEndPoint}/blocked-amounts/product/commission`,
    true
  )
}

export function fetchCurrentTasksAjax({
  keyword,
  skip = 0,
  take = 100,
  startDate,
  endDate,
  status = []
}) {
  const params = {}
  if (keyword) params.keyword = keyword
  if (skip) params.skip = skip
  if (take) params.take = take + 1
  if (startDate) params.startDate = startDate.startOf('day').unix()
  if (endDate) params.endDate = endDate.endOf('day').unix()
  if (status) params.status = status

  let url = getUrlWithQueryString(
    `${baseUrl}/currenttask/v1/current-task`,
    params
  )
  return jsonRequest(url, true)
}

export function fetchCurrentTaskDetailsAjax(id) {
  var url = `${baseUrl}/currenttask/v1/current-task/details?id=${id}`
  return jsonRequest(url, true)
}

export function downloadSwiftCode(id, transactionDate) {
  if (!id || !transactionDate) {
    return
  }
  const url = `${baseUrl}/${transcationEndPoint}/transactions/swift-trasnfer-data-pdf?id=${id}&TransactionDate=${transactionDate}`
  return downloadFileRequest(url, 'swift', 'pdf', true)
}

export function exportTransactionDetails({
  id,
  transactionDate,
  AccountHolderPersonalNumber = null,
  IsJuniorAccount = null
} = {}) {
  if (!id || !transactionDate) {
    return
  }

  const payload = { id, TransactionDate: transactionDate }
  /**
   * Check if the account is a junior
   * otherwise, this will throw an error from api
   */
  if (AccountHolderPersonalNumber) {
    payload.AccountHolderPersonalNumber = AccountHolderPersonalNumber
    payload.IsJuniorAccount = !!AccountHolderPersonalNumber || IsJuniorAccount
  }

  const url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/transactions/export/pdf`,
    payload
  )
  return downloadFileRequest(url, `Transaction_Details_${id}`, 'pdf', true)
}

export function fetchTransactionFinancialSummaryAjax({
  startDate = moment().startOf('month'),
  endDate = moment(),
  includeAggregation = false,
  isIncome = false,
  categoryId = '',
  categoryName = '',
  subcategoryId = [],
  searchId = '',
  takeNextCount = 100
}) {
  startDate = moment(startDate)
    .startOf('day')
    .unix()
  endDate = moment(endDate)
    .endOf('day')
    .unix()

  const params = {
    startDate,
    endDate,
    includeAggregation,
    isIncome,
    categoryId,
    categoryName,
    subcategoryId,
    searchId: searchId ? searchId : '',
    takeNextCount: takeNextCount
  }

  let url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/finanncial-summary`,
    params
  )

  return jsonRequest(url, true, undefined, 'GET', {
    internalServerError: false,
    badRequest: false
  })
}

export const fetchTransactionCategoryListAjax = () => {
  let url = `${baseUrl}/${transcationEndPoint}/finanncial-summary/category-list`
  return jsonRequest(url, true, undefined, 'GET', {
    internalServerError: false,
    badRequest: false
  })
}

export function getDetailsFile(iban, fileName) {
  const url = `${baseUrl}/account/v4/debit/details/${iban}/interest/pdf`
  return downloadFileRequest(url, fileName, 'pdf', true)
}

export function fetchLimitedTransactionsAjax(
  {
    iban,
    skip = 0,
    take = 30,
    loadMoreTransactions = false,
    currency,
    categoryId,
    subcategoryId,
    keyword,
    IsJuniorAccount,
    accountHolderPersonalNumber
  },
  signal = null
) {
  const params = {}
  if (keyword) params.keyword = keyword
  if (iban) params.iban = iban
  if (currency) params.currency = currency

  if (skip) params.skip = skip
  if (categoryId) params.categoryId = categoryId
  if (subcategoryId) params.subcategoryId = subcategoryId
  if (take) params.take = loadMoreTransactions ? take : take
  if (IsJuniorAccount) params.IsJuniorAccount = IsJuniorAccount
  if (accountHolderPersonalNumber)
    params.accountHolderPersonalNumber = accountHolderPersonalNumber

  let url = getUrlWithQueryString(
    `${baseUrl}/${transcationEndPoint}/transactions/time-limited`,
    params
  )
  return jsonRequest(
    url,
    true,
    undefined,
    'GET',
    { internalServerError: false, badRequest: false },
    signal
  )
}

export function fetchSwiftNotificationPreference({ id, NotifyClient }) {
  var url = `${baseUrl}/transaction/v2/transactions/swift-notification-preference?Id=${id}&NotifyClient=${NotifyClient}`
  return jsonRequest(url, true, undefined, 'POST')
}

export function fetchDownloadSwiftOca(id, RoutingKey, transactionDate) {
  if (!id || !RoutingKey || !transactionDate) {
    return
  }
  const url = `${baseUrl}/transaction/v2/transactions/swift-trasnfer-data-pdf?Id=${id}&RoutingKey=${RoutingKey}&TransactionDate=${transactionDate}`
  return downloadFileRequest(url, 'swift', 'pdf', true)
}
